
import Vue from "vue";
import {ISelectItem} from "winfakt-vue-components";

const ICONS = [
	// Links & Navigation
	"external-link-alt", "link", "arrow-right", "arrow-left", "chevron-right",
	// Documents
	"file", "file-alt", "file-pdf", "file-invoice", "file-download", "file-export",
	// Actions
	"download", "upload", "print", "save", "trash", "pen", "edit", "copy",
	// Communication
	"envelope", "phone", "comment", "comments", "paper-plane",
	// Finance
	"euro-sign", "credit-card", "receipt", "calculator", "coins", "money-bill",
	// Users
	"user", "users", "user-plus", "user-check",
	// Status
	"check", "times", "exclamation", "info-circle", "question-circle",
	// Data
	"chart-bar", "chart-line", "chart-pie", "table", "list", "th",
	// Tools
	"cog", "cogs", "wrench", "tools", "sliders-h",
	// Misc
	"star", "heart", "bookmark", "tag", "tags", "search", "eye", "clock",
	"calendar", "bell", "home", "building", "map-marker-alt", "globe",
	"lock", "unlock", "key", "shield-alt", "sync", "refresh", "redo"
];

export default Vue.extend({
	props: {
		value: {
			type: String,
			default: ""
		},
		label: {
			type: String,
			default: "Icon"
		}
	},
	computed: {
		iconItems(): ISelectItem<string>[] {
			return ICONS.map(icon => ({
				text: icon,
				value: icon,
				icon
			}));
		}
	}
});
